// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3Yz_L","right":"styles_right__2JGU4"};